import { css } from "@emotion/core";
import { color, fontTypes, fontSizes } from "../../constants/commons";

export const customFormStyles = (isMobile?: boolean) => css`
  .heading-text {
    font-family: ${fontTypes.bodyFont};
    font-size: ${fontSizes.xs};
    color: ${color.lightishGray};
    margin-bottom: 1em;
  }
  .submitted-message {
    font-family: ${fontTypes.bold};
  }
  .submitted-message > :first-of-type {
    margin-bottom: 1em;
  }
  .submitted-modal-button {
    ${!isMobile ? "width: 50%;" : "width: 80%;"}
  }
`;
